import React, { Component } from "react";
import Design from "./404.scss";

class PageError extends Component {
  render() {
    return (
      <div>
        <div className={Design.container_404}>
          <a href="/patient-playlists">
            <img
              src="assets/img/DD-logo-long-blanc.png"
              className={Design.logo_digidocteur}
            />
          </a>
          <div className={Design.container_img}>
            <img
              className={Design.img_doctor_404}
              src="/assets/img/404-bg/404-x-ray.png"
            />
            <p className={Design.title_text_404}>
              Oups ! Cette url n'existe pas...
            </p>
            <p className={Design.text_404}>
              Pour éviter toute erreur, vous pouvez scanner le QR code sur les
              vidéos ou les flyers de votre médecin !
            </p>
            <a href="https://digidocteur.com" className={Design.btn_404}>
              Retour
            </a>
          </div>
        </div>
        <style
          dangerouslySetInnerHTML={{
            __html: `
                    body{
                        background-image: radial-gradient(closest-side, rgba(62, 154, 215, 0.76), rgb(46, 143, 227));
                    }`,
          }}
        />
      </div>
    );
  }
}

export default PageError;



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/404Page/404Page.jsx